import objectToArray from './lib/objectToArray';
import getUrlParameter from './lib/getUrlParameter';
import parseVendorConsent from './lib/parseVendorConsent';

import store from '../redux/reducers';
import {setConfiguration} from '../redux/actions';

function parseVendorList(vendorList) {
    if (vendorList) {
        let newVendorList = {...vendorList};

        // Remove stacks
        newVendorList.stacks = null;
        delete newVendorList.stacks;

        // Convert object to array
        newVendorList.purposes = objectToArray(vendorList.purposes);
        newVendorList.specialPurposes = objectToArray(vendorList.specialPurposes);
        newVendorList.features = objectToArray(vendorList.features);
        newVendorList.specialFeatures = objectToArray(vendorList.specialFeatures);
        newVendorList.vendors = objectToArray(vendorList.vendors);

        return newVendorList;
    }
}

function receiveMessage(event) {
    const consentId = getUrlParameter('consentId') || null;
    let json = null;

    //TODO: domain checking/keying!?

    try {
        json = JSON.parse(event.data);
    } catch (e) {
    }

    if (
        json && json.consentId && ((consentId && json.consentId === consentId) || (json.consentId === 'webadsConsentUi')) && json.message
    ) {
        json.message.static = json.message.static || {};
        json.message.static.purposeLegitimateInterest = json.message.static.purposeLegitimateInterest || {};
        [1, 3, 4, 5, 6].forEach((id) => json.message.static.purposeLegitimateInterest[id] = false);

        json.message.vendorList = parseVendorList(json.message.vendorList);
        if (!json.message.consentGiven) {
            json.message.defaultConsent = true;
            const consent = parseVendorConsent(json.message);
            json.message.vendorConsent = consent.vendorConsent;
            json.message.objectConsent = consent.objectConsent;
            json.message.specialFeatureOptins = consent.specialFeatureOptins;
            json.message.purposeConsent = consent.purposeConsent;
            json.message.purposeLegitimateInterest = consent.purposeLegitimateInterest;
        }
        // if (!json.message.vendorConsent) json.message.vendorConsent = parseVendorConsent(json.message);
        // if (!json.message.objectConsent) json.message.objectConsent = parseObjectConsent(json.message);

        store.dispatch((setConfiguration(json.message)));
    }

    return null;
}

export const CreatePostMessage = () => {
    window.addEventListener("message", receiveMessage, false);

    SendPostMessageLoaded();
};

export const sendPostMessage = () => {
    const {configuration} = store.getState();
    const consentUrlId = getUrlParameter('consentId') || null;

    let consentId = (consentUrlId) ? consentUrlId : 'webadsConsentUi';

    configuration.purposeLegitimateInterest = configuration.purposeLegitimateInterest || {};
    [1, 3, 4, 5, 6].forEach((id) => configuration.purposeLegitimateInterest[id] = false);

    const message = JSON.stringify({
        consentId,
        message: {
            vendorConsent: configuration.vendorConsent,
            objectConsent: configuration.objectConsent,
            purposeConsent: configuration.purposeConsent,
            purposeLegitimateInterest: configuration.purposeLegitimateInterest,
            specialFeatureOptins: configuration.specialFeatureOptins
        }
    });

    try {
        if (window.parent) window.parent.postMessage(message, '*');
    } catch (e) {
        if (window.parent) window.parent.postMessage(message, '*');
    }
};

const SendPostMessageLoaded = () => {
    const consentUrlId = getUrlParameter('consentId') || null;
    let consentId = (consentUrlId) ? consentUrlId : 'webadsConsentUi';

    const message = JSON.stringify({
        consentId,
        message: {loaded: true}
    });

    try {
        if (window.parent) window.parent.postMessage(message, '*');
    } catch (e) {
        if (window.parent) window.parent.postMessage(message, '*');
    }
};

export const sendPostMessageNoTracking = () => {
    const consentUrlId = getUrlParameter('consentId') || null;

    let consentId = (consentUrlId) ? consentUrlId : 'webadsConsentUi';

    const message = JSON.stringify({
        consentId,
        message: {noTracking: true}
    });

    try {
        if (window.parent) window.parent.postMessage(message, '*');
    } catch (e) {
        if (window.parent) window.parent.postMessage(message, '*');
    }
};
